"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullFunction = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return undefined;
};
//# sourceMappingURL=Core.js.map